import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  name: PropTypes.string,
  info: PropTypes.string,
  image: PropTypes.shape(ImageProp.propType),
};

export default { propType };
